<template>
  <!-- 售后服务 -->
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button type="primary" size="small" @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 类型 -->
      <el-table-column prop="type" label="类型" min-width="90px" align="center">
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'type' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.type"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.type }}
          </div>
        </template>
      </el-table-column>
      <!-- 类别 -->
      <el-table-column
        prop="category"
        label="类别"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'category' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.category"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.category }}
          </div>
        </template>
      </el-table-column>
      <!-- 规划 -->
      <el-table-column label="规划" align="center">
        <!-- 计划 -->
        <el-table-column
          prop="plan"
          label="计划"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'plan' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.plan"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.plan }}
            </div>
          </template>
        </el-table-column>
        <!-- 已完成 -->
        <el-table-column
          prop="completed"
          label="已完成"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="editField === 'completed' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.completed"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.completed }}
            </div>
          </template>
        </el-table-column>
        <!-- 待完成 -->
        <el-table-column
          prop="unfinished"
          label="待完成"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'unfinished' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.unfinished"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.unfinished }}
            </div>
          </template>
        </el-table-column>
        <!-- 建设计划 -->
        <el-table-column
          prop="buildPlan"
          label="建设计划"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'buildPlan' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.buildPlan"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.buildPlan }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 售后评价 -->
      <el-table-column label="售后评价" align="center">
        <!-- 配件供应评价 -->
        <el-table-column
          prop="accessoriesEvaluation"
          label="配件供应评价"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'accessoriesEvaluation' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.accessoriesEvaluation"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.accessoriesEvaluation }}
            </div>
          </template>
        </el-table-column>
        <!-- 售后渠道评价 -->
        <el-table-column
          prop="channelEvaluation"
          label="售后渠道评价"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'channelEvaluation' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.channelEvaluation"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.channelEvaluation }}
            </div>
          </template>
        </el-table-column>
        <!-- 质量信息反馈评价 -->
        <el-table-column
          prop="qualityFeedbackEvaluation"
          label="质量信息反馈评价"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'qualityFeedbackEvaluation' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.qualityFeedbackEvaluation"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.qualityFeedbackEvaluation }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'remark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.remark }}
          </div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column label="操作" align="center" width="90px" fixed="right">
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateSaleAfterServiceApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [], // 表格数据
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        type: "", // 类型
        category: "", // 类别
        plan: "", // 计划
        completed: "", // 已完成
        unfinished: "", // 待完成
        buildPlan: "", // 建设计划
        accessoriesEvaluation: "", // 配件供应评价
        channelEvaluation: "", // 售后渠道评价
        qualityFeedbackEvaluation: "", // 质量信息反馈评价
        remark: "" // 备注
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateSaleAfterServiceApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data || [];
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
